module.exports = __webpack_public_path__ + "media/St 4-Screen 2.7b408846.wav";